import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import IconButton from '@material-ui/core/IconButton';

const Footer = () => {
    return (
        <footer className='mt-5 text-center'>
            <div className='flex w-max m-auto mb-3'>
                <a href="https://www.facebook.com/mdtajuuddintarek/" target='_blank' rel='noreferrer'>
                    <IconButton className="footer_icon_area">
                        <FacebookIcon className='footer_icon' />
                    </IconButton>
                </a>
                <a href="https://www.linkedin.com/in/mdtajuuddintarek/" target='_blank' rel='noreferrer'>
                    <IconButton className="footer_icon_area">
                        <LinkedInIcon className='footer_icon' />
                    </IconButton>
                </a>
                <a href="https://github.com/mdtaju" target='_blank' rel='noreferrer'>
                    <IconButton className="footer_icon_area">
                        <GitHubIcon className='footer_icon' />
                    </IconButton>
                </a>
            </div>
            <h1 className='text-lg'>Developed by Md. Tajuuddin Tarek</h1>
            <h1 className='text-md mb-5'>&copy; All right reserve 2021</h1>
        </footer>
    );
};

export default Footer;